// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_icon__zj710 {
    --icon-color: var(--icon-color-custom, currentcolor);
    --icon-color-outer: var(--icon-color-outer-custom, var(--icon-color));

    --icon-fill-color: var(--icon-fill-color-custom, none);

    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    overflow: visible;
    max-width: 100%;
    max-height: 100%;
    vertical-align: middle;
}

.styles_icon__zj710 svg {
    flex-shrink: 0;
    max-width: 100%;
    max-height: 100%;
    overflow: visible;
}

.styles_icon__zj710 svg * {
    transition: 0.2s;
    vector-effect: non-scaling-stroke; /* Prevents the stroke from thickening if the SVG scales */
}
`, "",{"version":3,"sources":["webpack://./src/components/Icon/styles.module.css"],"names":[],"mappings":"AAAA;IACI,oDAAoD;IACpD,qEAAqE;;IAErE,sDAAsD;;IAEtD,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iCAAiC,EAAE,0DAA0D;AACjG","sourcesContent":[".icon {\n    --icon-color: var(--icon-color-custom, currentcolor);\n    --icon-color-outer: var(--icon-color-outer-custom, var(--icon-color));\n\n    --icon-fill-color: var(--icon-fill-color-custom, none);\n\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    overflow: visible;\n    max-width: 100%;\n    max-height: 100%;\n    vertical-align: middle;\n}\n\n.icon svg {\n    flex-shrink: 0;\n    max-width: 100%;\n    max-height: 100%;\n    overflow: visible;\n}\n\n.icon svg * {\n    transition: 0.2s;\n    vector-effect: non-scaling-stroke; /* Prevents the stroke from thickening if the SVG scales */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `styles_icon__zj710`
};
export default ___CSS_LOADER_EXPORT___;
